import { StorefrontOptions } from '../types';

let options: StorefrontOptions = {
  storeIdentifier: '',
  environment: 'prod',
};

export function setOptions(opts: StorefrontOptions) {
  options = opts;
}

export function getOptions() {
  return options;
}
